function Hawaii({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_1334)">
      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
      <path d="M16 32C20.0573 32 23.7611 30.489 26.5816 28H5.41833C8.23877 30.489 11.9426 32 16 32Z" fill="#D80027"/>
      <path d="M0.504028 20.0001C0.869341 21.4192 1.42472 22.762 2.14097 24.0001H29.8589C30.5752 22.762 31.1305 21.4192 31.4958 20.0001L16 18.7827L0.504028 20.0001Z" fill="#0052B4"/>
      <path d="M31.4959 12C31.1306 10.5809 30.5752 9.23812 29.859 8L16 7.65219C16 4.85763 16 2.21656 16 0C14.8114 0 13.653 0.129687 12.5384 0.3755C12.517 0.38025 2.08691 8.60738 2.08691 16C2.3536 16.0464 16 17.3913 16 17.3913C16 17.3913 16 14.3438 16 12H31.4959Z" fill="#0052B4"/>
      <path d="M16 9.98253V1.98253H10.9328L12.5389 0.376465C5.94569 1.83059 0.87975 7.35084 0.104375 14.1738C0.03625 14.7732 0 15.3823 0 15.9999H8.10437V12.811L11.3249 15.9999H17.0489L10.9327 9.98253H16Z" fill="#F0F0F0"/>
      <path d="M16.0073 15.9999L9.98994 9.98257H8.10437V9.98263L14.1217 15.9999H6.08694V7.99995H29.859C28.9879 6.49414 27.878 5.14389 26.5817 3.99995H6.08694V3.44214C4.47269 4.7182 3.11069 6.2987 2.08694 8.09707V15.9999H0C0 17.3811 0.175 18.7215 0.504062 19.9999H31.4959C31.825 18.7214 32 17.3811 32 15.9999H16.0073Z" fill="#D80027"/>
    </g>
  </svg>
  `;

  return baseXml;
}

export default Hawaii;
